import config from '@bedrock-rdk/config';

export const getUpsell = lock => {
  if (!config.featureFlipping.upsellFlow) {
    return null;
  }

  if (!lock) {
    return null;
  }

  const unlockTarget = lock.reasonAttributes ? lock.reasonAttributes.unlockTarget : null;
  if (!unlockTarget) {
    return null;
  }

  const upsell = unlockTarget[`value_${unlockTarget.type}`];

  return upsell && upsell.reference === 'upsell' ? upsell : null;
};
